import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './maintenance-control.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenanceControlDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const maintenanceControlEntity = useAppSelector(state => state.maintenanceControl.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="maintenanceControlDetailsHeading">
          <Translate contentKey="fleetSenseApp.maintenanceControl.detail.title">MaintenanceControl</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{maintenanceControlEntity.id}</dd>
          <dt>
            <span id="maintenance">
              <Translate contentKey="fleetSenseApp.maintenanceControl.maintenance">Maintenance</Translate>
            </span>
          </dt>
          <dd>{maintenanceControlEntity.maintenance ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceControl.maintenanceReview">Maintenance Review</Translate>
          </dt>
          <dd>{maintenanceControlEntity.maintenanceReview ? maintenanceControlEntity.maintenanceReview.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceControl.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{maintenanceControlEntity.truckImplement ? maintenanceControlEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceControl.company">Company</Translate>
          </dt>
          <dd>{maintenanceControlEntity.company ? maintenanceControlEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/maintenance-control" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/maintenance-control/${maintenanceControlEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MaintenanceControlDetail;
